export default {"src":"/_next/static/media/lightning_64.d1837ef3.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};